<template>
  <div
    class="app sanvault-app"
    :class="{
      'sanvault-app--authenticated': isLogged,
      'sanvault-app--public': !isLogged
    }"
  >
    <div v-if="!loading">
      <MainHeader v-if="isLogged && currentRoute !== '/'" />
      <MainSidebar v-if="isLogged && currentRoute !== '/'" />
      <div class="main-content d-flex flex-column transition overflow-hidden" :class="{'center-main-content': !isLogged, 'justify-content-start validate-home-page': currentRoute === '/'}">
        <router-view />
        <MainFooter v-if="isLogged && currentRoute !== '/'" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, watchEffect } from "vue";
import { mapActions, mapGetters } from 'vuex';
import { useRoute } from 'vue-router';
import stateStore from "./utils/store";

import { isAuthenticated } from './services/authService';
import api from './config/axios.js';
import { canAccessPath, getDefaultModulePath } from './helpers/permissions.js';
import { isPublicEventPath, isPublicPath } from './helpers/publicRoutes.js';

import MainHeader from "./components/Layouts/MainHeader.vue";
import MainSidebar from "./components/Layouts/MainSidebar.vue";
import MainFooter from "./components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "App",
  data () {
    return {
      isLogged: false,
      loading: true
    }
  },
  components: {
    MainHeader,
    MainSidebar,
    MainFooter,
  },
  methods: {
    ...mapActions([
      "setConfiguration"
    ])
  },
  computed: {
    ...mapGetters([
      'getPermissions'
    ]),
  },
  watch:{
    getPermissions(data){
      if(data && data.length > 0){
        if(!canAccessPath(data, window.location.pathname)){
          window.location.href = getDefaultModulePath(data);
        }
      }
    }
  },
  async created() {
    const pathname = window.location.pathname;
    const isEventPublicRoute = isPublicEventPath(pathname);

    if(isEventPublicRoute || pathname === "/conexao-empresarial"){
      this.isLogged = false;
      this.loading = false;
      return;
    }

    if(!isPublicPath(pathname)){
      this.isLogged = true;
      this.loading = false;
      return;
    }

    this.isLogged = false;
    this.loading = false;

    if(await isAuthenticated()){
      const response = await api.axios.get('/api/me');
      window.location.href = getDefaultModulePath(response.data.permissions || []);
      return;
    }
  },
  mounted() {
    document.body.classList.add("bg-body-secondary");
    document.title = window.location.pathname === "/eventos/inscricoes"
      ? "Eventos e inscrições | Sanvault"
      : "Sanvault | Governança de gravações e inteligência operacional";

    this.setConfiguration();
  },
  setup() {
    const route = useRoute();
    const stateStoreInstance = stateStore;
    
    const currentRoute = computed(() => route.path);

    watchEffect(() => {
      if (stateStoreInstance.open) {
        document.body.classList.remove("sidebar-show");
        document.body.classList.add("sidebar-hide");
      } else {
        document.body.classList.remove("sidebar-hide");
        document.body.classList.add("sidebar-show");
      }
    });

    return {
      currentRoute
    };
  },
});
</script>
<style scoped>
.validate-home-page{
  padding: unset !important;
}
</style>
